import { css } from 'styled-components';
import { WithFontBody, WithFontHead } from 'styles/commonCss';
import { mqSmallMin } from 'styled/tools/media-queries';

/*
  This can be later used in a createGlobalStyle in our _app.tsx to
  apply the styling to the entire application, instead of importing
  _elements.scss in app.scss
*/

export const Elements = css`
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    ${WithFontHead}
    color: #000;
    padding: 0;
    margin: 0;
  }

  h1,
  h2 {
    letter-spacing: var(--flag-letter-spacing-1);
    @media ${mqSmallMin} {
      letter-spacing: var(--flag-letter-spacing-2);
    }
  }

  p,
  span,
  label,
  small {
    ${WithFontBody}
    color: #000;
  }

  p {
    display: block;
  }

  p:empty {
    display: none;
  }

  a,
  a * {
    color: var(--text-primary);

    &:focus,
    &:hover {
      color: var(--text-primary);
    }
  }

  ul,
  ol {
    list-style: none;
    list-style-position: inside;
    padding: 0;
  }

  th,
  strong {
    font-weight: 500;
  }

  th,
  td {
    white-space: normal;
  }

  * {
    box-sizing: border-box;
    color: var(--text-primary);
    padding: 0;
    margin: 0;
  }

  html {
    background: var(--fill-brand);
  }

  body {
    transition: opacity 0.25s ease;
    transition-delay: 0.25s;
    opacity: 0;
    &.ready {
      opacity: 1 !important;
    }
  }

  /* White background here, not body, so footer artwork (z-index -1) shows through. */
  #__next {
    background: var(--fill-bright);
  }
`;
